module.exports = __webpack_public_path__ + "static/media/bam.4cf39010.png";